/* eslint-disable */
import axios from 'axios'
import config from '@/config'

export default {
    data() {
        return {
            check: false
        }
    },
    checkLoginTest(username, password) {
        const http = axios.create({
            baseURL: config.API_URL
        });
        http.defaults.headers.common['Content-Type'] = 'application/json'
        return http.post(`/auth`, {
            "username": username,
            "password": password
        });
    },
    checkLogin(username, password) {
        const http = axios.create({
            baseURL: config.API_URL
        });
        http.defaults.headers.common['Content-Type'] = 'application/json'
        return http.post(`/auth`, {
            "username": username,
            "password": password
        });
    },
    getCompany(token) {
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/user/company`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        });
    },
    createNewUser(data) {
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.post(`/users/register`, data, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
    },

    createShop(data) {
        const _token = localStorage._token;
        const http = axios.create({
            baseURL: config.API_URL
        });
        console.log(_token)
        return http.post(`/company/new`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
            }
        });
    },
    getVerifyDB(data) {
        const _token = localStorage._token;
        const http = axios.create({
            baseURL: config.API_URL
        }); //connect
        return http.post(`/company/connect`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
            }
        });
    },
    getVerifyDatabase(data) {
        const _token = localStorage._token;
        const http = axios.create({
            baseURL: config.API_URL
        }); //connect
        return http.post(`/company/verify`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
            }
        });
    },
    getEmpByuserCode(data) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/employee/usercode?code=` + data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    forgetPassword(data) {
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.post(`/users/forgetPassword/` + data, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
    },
    resetPassword(data) {
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.post(`/users/resetPassword`, data, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
    },
    verifyUser(_token) {
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/users/verifyAccount`, {
            params: {
                "t": _token
            },
            headers: {
                'Content-Type': 'application/json',
            }
        });
    },
    async isLogin() {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        let check = null;
        await http.get(`/employee/checklogin`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        }).then(response => {
            console.log(response)
            this.check = response.data;
        }).catch(err => {
            console.log(err)
            this.check = false;
        });
        console.log("dasa", _company_guid);
        console.log('this.check :'+this.check)
        if ((this.check == undefined || this.check == false) && (_company_guid != undefined) ) {
            console.log("checkif", this.check)
            localStorage.clear();
            this.check = false
        }  if ((this.check != undefined || this.check == true) && (_company_guid == undefined) ) {
            console.log("checkelse", this.check)
            this.check = false
        }else{
           
            console.log("checkelse", this.check)
            this.check = true
        }

        // const check = Response.data
        // return http.get(`/employee/checklogin`, {
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': 'Bearer ' + _token,
        //         'X-TenantID': _company_guid
        //     }
        // });

        // let _token = localStorage.getItem("_token")
        // let company_guid = localStorage.getItem("_company_guid");
        // let check = _token != undefined && _token != "" &&  company_guid != undefined && company_guid != "" ? true : false
        return this.check
    },
    async getpermissionByusercode(empcode) {
        console.log(empcode)
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/permission-control/Perm`, {
            params: {
                'emp_code': empcode,
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },
    getCheckUser(code) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/users/checkID/`+ code, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
    },




    _sendInvite(data){
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.post('company/invite', data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'companyGUID': _company_guid
            }
        });
    },
    _saveInviteToken(token, emp_code) {
        const _token = localStorage._token;
        const _company_guid = localStorage._company_guid;
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.get(`/employee/saveInvitetoken`, {
            params: {
                'token': token,
                'code': emp_code,
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + _token,
                'X-TenantID': _company_guid
            }
        });
      },  
      _registerInvite(data,invite) {
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.post(`/users/register?invite=`+invite, data, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
    },
 
}